import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function Bespoke() {
  return <section id="bespoke" className="py-24 md:py-32 relative overflow-hidden" data-id="element-29">
      <div className="absolute inset-0 bg-gradient-to-br from-plum-800 via-plum-900 to-plum-950" data-id="element-30"></div>
      <div className="absolute inset-0 opacity-30 mix-blend-overlay" data-id="element-31">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-lavender-400 rounded-full blur-3xl" data-id="element-32"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-rose-500 rounded-full blur-3xl" data-id="element-33"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center mb-6" data-id="element-35">
          <div className="w-16 h-16 rounded-full border border-lavender-300/40 flex items-center justify-center bg-plum-950/50 backdrop-blur-sm" data-id="element-36">
            <Lock className="text-lavender-200" size={24} strokeWidth={1.5} data-id="element-37" />
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-serif text-4xl md:text-5xl text-lavender-50 mb-8" data-id="element-38">
          Bespoke{' '}
          <span className="italic bg-gradient-to-r from-lavender-300 to-rose-400 bg-clip-text text-transparent" data-id="element-39">
            Desires
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-6 text-lavender-100/85 font-light text-lg leading-relaxed" data-id="element-40">
          <p data-id="element-41">
            At Afriel, we understand that pleasure is deeply personal. We
            provide a judgment-free, fully confidential environment where your
            unique preferences and personal explorations are welcomed with
            open-minded sophistication.
          </p>
          <p data-id="element-42">
            Whether you are seeking to explore specific sensory dynamics,
            incorporate bespoke elements into your session, or curate a tailored
            experience, our practitioners are adept at accommodating specialized
            requests.
          </p>
          <p className="text-rose-300 italic" data-id="element-43">
            All bespoke journeys begin with a discreet consultation to ensure
            mutual understanding, comfort, and the highest standard of care.
          </p>
        </motion.div>
      </div>
    </section>;
}